import { saveAs } from 'file-saver'
import { Repository } from '@/repository/repository'

const apiRepository = Repository.call('labels')
const state = {}
const getters = {}
const mutations = {}

const actions = {
  async downloadLabels ({ commit }, orders) {
    const dirtyCustomerOrderCode = []
    const query = orders
      .map(order => {
        const {
          id,
          partner,
          supplierOrderCode,
          volumeTotal,
          palletTotal,
          palletEquivalentNumber
        } = order

        if ((volumeTotal === 0 && palletTotal === 0 && palletEquivalentNumber === 0) || partner === 'N.A.') {
          dirtyCustomerOrderCode.push(supplierOrderCode)
          return null
        }

        return `customerOrderIds=${id}`
      })
      .filter(b => b)
      .join('&')

    if (dirtyCustomerOrderCode.length) {
      return {
        error: true,
        customerOrderCode: dirtyCustomerOrderCode
      }
    }

    const file = await apiRepository.postLmLabels(query)
    if (!file || file.status !== 200) return false

    const timeStamp = Math.floor(Date.now())
    const blob = new Blob([file.data], { type: 'application/pdf' })
    saveAs(blob, `${timeStamp}.pdf`)
    return file
  },
  async downloadDHLLabel ({ commit }, orders) {
    const dirtyCustomerOrderCode = []

    const data = orders.reduce((acc, order) => {
      const { storeCode } = order.store
      const {
        customerOrderCode,
        volumeTotal,
        palletTotal,
        palletEquivalentNumber,
        partner
      } = order

      if (volumeTotal === 0 && palletTotal === 0 && palletEquivalentNumber === 0) {
        dirtyCustomerOrderCode.push(customerOrderCode)
      }

      if (partner === 'DHL') acc.push({ customerOrderCode, storeCode })
      return acc
    }, [])

    if (dirtyCustomerOrderCode.length) {
      return {
        error: true,
        customerOrderCode: dirtyCustomerOrderCode
      }
    }

    let results = []
    const unresolvedToken = obj => {
      return new Promise((resolve, reject) => {
        resolve(apiRepository.getDHLLabel(obj))
      })
    }

    const getPDF = token => {
      return new Promise(async (resolve, reject) => {
        const file = await apiRepository.getDHLFile(token)
        if (!file || file.status !== 200) reject(file)

        const fileName = (file.headers && file.headers['filename']) ? file.headers['filename'] : `${Math.floor(Date.now())}.pdf`
        const blob = new Blob([file.data], { type: 'application/pdf' })
        saveAs(blob, fileName)
        resolve(file)
      })
    }

    const arrData = await Promise.all(data.map(unresolvedToken)).then(blob => blob)
    arrData.forEach(async el => {
      const { data } = el
      results = await Promise.all(data.map(getPDF)).then(data => data)
    })
    return results
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/labels.js